/* Approved 11 October 2026: selling amounts round down to whole pounds.
 * Supplier reference data and existing Ethnicraft prices remain unchanged. */
window.FultonsSellingPrice = window.FultonsSellingPrice || ((value, preserveEthnicraft = false) => {
  if (preserveEthnicraft || typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return value;
  return Math.floor(value + 1e-9);
});
(() => {
  'use strict';
  const data = window.FultonsCattelanStorageTables;
  if (!data) return;
  const money = value => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',maximumFractionDigits:0}).format(window.FultonsSellingPrice(value));
  const make = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  };
  function picker(label, id, changed, product = false) {
    const field = make('div', 'fct-field' + (product ? ' fct-model' : ''));
    const caption = make('p', 'fct-label', label);
    const details = make('details', 'fce-picker');
    const summary = make('summary'); summary.id = id;
    const list = make('div', 'fce-picker-list'); list.id = id + 'Options';
    list.setAttribute('role','group'); list.setAttribute('aria-label',label + ' options');
    summary.setAttribute('aria-controls',list.id);
    details.append(summary,list); field.append(caption,details);
    const flow=()=>!!details.closest('.fcc[data-cattelan-compact]');
    const closeOthers=()=>{if(flow())details.closest('.fcc').querySelectorAll('.fce-picker[open]').forEach(other=>{if(other!==details)other.open=false;});};
    summary.addEventListener('click',closeOthers);
    let selected = '', entries = [];
    function content(target, item, arrow) {
      target.replaceChildren();
      const img = make('img'); img.src = item.thumbnail?.startsWith('theme-asset:') ? window.FultonsArenaOptionAssets?.[item.thumbnail.slice(12)] || '' : item.thumbnail; img.alt = ''; img.width = product ? 80 : 38; img.height = product ? 60 : 38; img.loading = 'lazy';
      const text = make('span','fct-choice-text',item.label);
      if (item.priceGbp) text.append(make('small','fct-choice-price','Fultons price ' + money(item.priceGbp) + (item.priceUnit ? ' · ' + item.priceUnit : '')));
      target.append(img,text);
      if (arrow) { const icon = make('span','fce-picker-arrow','⌄'); icon.setAttribute('aria-hidden','true'); target.append(icon); }
    }
    function update(items, value) {
      entries = items; selected = value;
      const chosen = items.find(x=>x.value===value) || items[0];
      if (!chosen) return;
      content(summary,chosen,true);
      summary.setAttribute('aria-label',label + ': ' + chosen.label + (chosen.priceGbp ? ' — ' + money(chosen.priceGbp) : ''));
      list.replaceChildren();
      items.forEach(item=>{
        const button=make('button'); button.type='button'; button.dataset.value=item.value;
        button.setAttribute('aria-pressed',String(item.value===value));
        content(button,item,false);
        button.addEventListener('click',()=>{changed(item.value);details.open=false;summary.focus({preventScroll:true});});
        list.append(button);
      });
    }
    details.addEventListener('keydown',event=>{
      if(event.key==='Escape'){details.open=false;summary.focus({preventScroll:true});event.preventDefault();return;}
      if(event.key==='Tab'&&flow()){requestAnimationFrame(()=>{if(!details.contains(document.activeElement))details.open=false;});return;}
      if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
      closeOthers();
      event.preventDefault();details.open=true;
      const buttons=[...list.querySelectorAll('button')],i=buttons.indexOf(document.activeElement);
      const next=event.key==='Home'?0:event.key==='End'?buttons.length-1:i<0?Math.max(0,entries.findIndex(x=>x.value===selected)):(i+(event.key==='ArrowDown'?1:-1)+buttons.length)%buttons.length;
      buttons[next]?.focus();
    });
    return {field,update};
  }
  function closeOutside(event) {
    document.querySelectorAll('.fct-controls .fce-picker[open]').forEach(details=>{
      const sibling=details.closest('.fcc[data-cattelan-compact]')&&event.target.closest('.fcc[data-cattelan-compact] .fce-picker');
      if(!details.contains(event.target)&&!sibling)details.open=false;
    });
  }
  document.addEventListener('pointerdown',closeOutside);
  document.addEventListener('focusin',closeOutside);
  function render() {
    const id=String(new URL(location.href).searchParams.get('draft_product')||window.FultonsPriceTrial?.productId||'');
    const group=data.products[id],source=window.FultonsProductOptions?.[id];
    if(!group||!source)return;
    const root=document.querySelector('#MainContent .catalogue-proof:not([hidden]),#MainContent .pdp-refined:not([hidden])');
    const legacy=root?.querySelector('#FultonsCattelanOption'),box=legacy?.closest('.fcc');
    if(!legacy||!box||box.dataset.cattelanVisualReady)return;
    if(source.options.length!==group.options.length||source.options.some((option,i)=>option.label!==group.options[i].label))return;
    box.dataset.cattelanVisualReady='true';box.classList.add('fct-ready');legacy.hidden=true;
    const controls=make('div','fct-controls'),finishes=make('div','fct-finishes'),configurationNote=make('p','fct-note');
    const selectionKey='fultons:cattelan-storage-table:'+id;
    let values=new Map(), current=Number(legacy.value)||0;
    const arenaEntry={"15883627757951":{"wood-bond":"Arena Bond — large table plus one swivel companion"},"15883627954559":{"keramik-100":"Arena Keramik Bond — Ø100 × 35 cm ceramic table + Ø90 × 42 cm swivel glass table"}};
    const explicitArenaLabel=arenaEntry[id]?.[new URL(location.href).searchParams.get('arena_model')];
    const explicitArenaIndex=typeof explicitArenaLabel==='string'?source.options.findIndex(option=>option.label===explicitArenaLabel):-1;
    try{
      const saved=JSON.parse(sessionStorage.getItem(selectionKey)||'null');
      const index=source.options.findIndex(option=>option.label===saved?.label&&(option.sizeLabel||'')===saved?.sizeLabel);
      if(explicitArenaIndex<0&&index>=0){legacy.value=String(index);current=index;if(Array.isArray(saved.finishes))values=new Map(saved.finishes);}
    }catch{}
    if(explicitArenaIndex>=0){legacy.value=String(explicitArenaIndex);current=explicitArenaIndex;}
    const configurations=group.options.map((option,index)=>({...option,value:String(index),priceGbp:source.options[index].priceGbp}));
    const models=picker('1. Size & configuration','CattelanStorageTableChoice',value=>{
      legacy.value=value;legacy.dispatchEvent(new Event('change',{bubbles:true}));
    },true);
    function saveSelection(){
      const option=source.options[current];
      try{sessionStorage.setItem(selectionKey,JSON.stringify({label:option.label,sizeLabel:option.sizeLabel||'',finishes:[...values]}));}catch{}
    }
    function updateEnquiry(){
      const form=document.querySelector('#FultonsEnquiry form');if(!form)return;
      const option=source.options[current],configuration=group.options[current];
      const description=[option.label,option.sizeLabel,...finishSummary(),'Fultons price '+money(option.priceGbp)+(configuration.priceUnit?' · '+configuration.priceUnit:''),option.note].filter(Boolean).join('\n');
      let field=form.querySelector('input[name="contact[Selected configuration]"]');
      if(!field){field=make('input');field.type='hidden';field.name='contact[Selected configuration]';form.append(field);}
      field.value=description;field.dataset.cattelanSelected='true';
      let summary=form.querySelector('[data-cattelan-selection]');
      if(!summary){summary=make('div','fcc-enquiry-summary');summary.dataset.cattelanSelection='true';form.prepend(summary);}
      summary.replaceChildren(make('strong',null,'Your selected option'),make('p',null,description));
    }
    function finishSummary(){
      const option=group.options[current];
      const lines=option.finishes.map(g=>g.label+': '+(g.fixedSet?g.swatches.map(key=>data.swatches[key].label).join(' / '):data.swatches[values.get(g.label)]?.label||''));
      box.dataset.selectedFinishSummary=lines.join('\n');if(id==='15883627954559')box.dataset.arenaCeramicTop=option.finishes.some(g=>g.label==='Ceramic main top')?values.get('Ceramic main top')||'':'';return lines;
    }
    function sync(){
      current=Number(legacy.value)||0;
      models.update(configurations,String(current));
      configurationNote.textContent=group.options[current].note||'';configurationNote.hidden=!configurationNote.textContent;
      finishes.replaceChildren();
      [...group.options[current].finishes].sort((a,b)=>Number(!/top|surface/i.test(a.label))-Number(!/top|surface/i.test(b.label))).forEach((g,index)=>{
        const items=g.fixedSet?[{value:'set',label:g.swatches.map(key=>data.swatches[key].label).join(' / '),thumbnail:data.swatches[g.swatches[0]].thumbnail}]:g.swatches.map(key=>({value:key,...data.swatches[key]}));
        let selected=items.some(x=>x.value===values.get(g.label))?values.get(g.label):items[0].value;
        values.set(g.label,selected);
        const control=picker((index+2)+'. '+g.label,'CattelanFinish'+index,value=>{
          values.set(g.label,value);control.update(items,value);finishSummary();saveSelection();updateEnquiry();
          const status=box.querySelector('.fcc-status');if(status)status.textContent='';
        });
        control.update(items,selected);finishes.append(control.field);
      });
      finishSummary();saveSelection();updateEnquiry();
    }
    if(group.introduction)controls.append(make('p','fct-note',group.introduction));
    controls.append(models.field,configurationNote,finishes);
    if(group.options.some(option=>option.thumbnailKind==='product')) controls.append(make('p','fct-note','Product images illustrate the model; dimensions and finishes are listed with each option.'));
    legacy.after(controls);
    legacy.addEventListener('change',sync);
    box.querySelector('.fcc-enquire')?.addEventListener('click',updateEnquiry);
    legacy.dispatchEvent(new Event('change',{bubbles:true}));
  }
  let pending=false;
  const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;render();});};
  new MutationObserver(schedule).observe(document.getElementById('MainContent')||document.documentElement,{childList:true,subtree:true});
  document.addEventListener('fultons:catalogue-updated',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
})();

